import { createAction } from 'redux-actions';

import { appContextActionTypes } from './constants';

/**
 * dispatch(mergeDeepAppContextActionCreator({ appVersion: 1.0 }));
 */
export const mergeDeepAppContextActionCreator = createAction(appContextActionTypes.MERGE_CONTEXT_DEEP);
